/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Architect spécialisé startups. Je conçois des MVP et plateformes SaaS rentables avec IA et automatisation. Méthode IMPACT. Audit gratuit 24h.`)
};

const en_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Architect specializing in startups. I design profitable MVPs and SaaS platforms with AI and automation. IMPACT method. Free 24-h audit.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.meta_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("meta_description", locale)
	if (locale === "fr") return fr_meta_description(inputs)
	return en_meta_description(inputs)
};